import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SwalComponent} from '@sweetalert2/ngx-sweetalert2';
import {Router} from '@angular/router';
import {NgxSpinnerService} from 'ngx-spinner';
import {ProductCategory} from '../models/productCategory';
import {CategoryService} from '../services/category.service';

declare var $: any;

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {
  page = 1;
  pages = 2;
  selector: string = '.categories-list';

  @ViewChild('closeCreateModal') closeCreateModal: ElementRef;
  @ViewChild('closeUpdateModal') closeUpdateModal: ElementRef;
  @ViewChild('brandName') brandNameInput: ElementRef;
  @ViewChild('brandStatus') brandStatusInput: ElementRef;
  @ViewChild('errorSwal') private errorSwal: SwalComponent;
  @ViewChild('successSwal') private successSwal: SwalComponent;

  public searchText;
  public selectedId;
  public selectedName;
  categories: [ProductCategory];
  totalCategories = 0;
  category: ProductCategory;
  errorMessage = '';
  deleteIndexForCategory = -1; // Current category array index

  constructor(private categoryService: CategoryService,
              private router: Router,
              private spinner: NgxSpinnerService) {
  }

  ngOnInit() {
    this.spinner.show();
    this.getCategories();
    this.clearCategory();
    setTimeout(() => {
      /** spinner ends after 5 seconds */
      this.spinner.hide();
    }, 1000);
    this.onScroll();
  }

  getCategories() {
    this.categoryService.getCategories(this.page).subscribe(res => {
      this.categories = res.docs;
      this.pages = res.pages;
      this.totalCategories = res.total;
      this.sorting();
    }, error => {
      console.log(error);
      if (error.status === 403) {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        console.log('Error:', error);
      }
    });
  }

  createCategory() {
    if (!this.checkIsFieldsOkay()) { return; }
    if (this.isExist(name, 0)) { return; }
    this.spinner.show();
    this.categoryService.createCategory(this.category).subscribe(response => {
      this.spinner.hide();
      this.successSwal.text = 'Kategori  başarıyla oluşturuldu!';
      this.successSwal.show();
      this.closeCreateModal.nativeElement.click();
      this.page = 1;
      this.getCategories();
      this.clearCategory();
    }, error => {
      this.spinner.hide();
      this.errorSwal.text = 'Kategori oluşturulurken hata oluştu!';
      this.errorSwal.show();
    });

  }


  deleteCategory(id) {
    if (id === '' || id === undefined) {
      this.errorSwal.title = 'Kategori id alınamadı!';
      this.errorSwal.show();
      return;
    }
    this.spinner.show();
    this.categoryService.deleteCategory(id).subscribe(res => {
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.page = 1;
      this.getCategories();
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.spinner.hide();
        if (error.retCode !== 1) {
          this.errorSwal.text = 'Kategori silinirken hata oluştu!';
          this.errorSwal.show();
        } else {
          this.errorSwal.text = error.message;
          this.errorSwal.show();
        }
      }
    });
  }

  updateCategory() {
    if (!this.checkIsFieldsOkay()) {  return; }
    if (this.isExist(this.category.name, this.category._id)) { return; }
    this.spinner.show();

    this.categoryService.updateCategory(this.category, this.category._id).subscribe(res => {
      this.successSwal.title = 'Başarılı!';
      this.successSwal.show();
      this.closeUpdateModal.nativeElement.click();
      this.page = 1;
      this.getCategories();
      this.clearCategory();
      this.spinner.hide();
    }, error => {
      if (error.message === 'Error: Access Denied') {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        this.router.navigate(['/login']);
        this.spinner.hide();
      } else {
        this.errorSwal.title = error.status;
        this.errorSwal.text = error.error;
        this.errorSwal.show();
        this.spinner.hide();
      }
    });
  }
  selected(id, name) {
    this.selectedId = id;
    this.selectedName = name;
  }
  checkIsFieldsOkay(): boolean {
    let isOkay = true;
    if (this.category.name === '' || this.category.name === undefined) { isOkay = false; }
    if (this.category.status.toString() === '-1' || this.category.status === -1 || this.category.status === undefined) { isOkay = false; }
    if (!isOkay) {
      this.errorSwal.text = 'Lütfen tüm alanları doldurunuz!';
      this.errorSwal.show();
      return false;
    } else {
      return true;
    }
  }

  isExist(categoryName, id) {
    const result =  this.categories.some(x =>  x.name.toLowerCase() === categoryName.toLowerCase() && x._id !== id);
    if (result) {
      this.errorMessage = 'Bu isimli bir marka mevcuttur!';
      this.spinner.hide();
    }
    return result;
  }

  setCategory(category) {
    this.clearCategory();
    this.category = Object.assign({}, category);
    this.deleteIndexForCategory = this.categories.indexOf(category);
  }

  clearCategory() {
    this.category = new ProductCategory();
    this.category.status = -1;
    this.errorMessage = '';

  }
  sorting() {
    this.categories.sort(function(a, b) {
      if (a.name < b.name) { return -1; }
      if (a.name > b.name) { return 1; }
      return 0;
    });
  }

  setCategoryId(id) {
    localStorage.setItem('categoryId', id);
  }

  onScroll() {
    console.log('ddd');
    if (this.page + 1 > this.pages) { return; }
    $('#page-loader').fadeIn();
    this.page += 1;
    this.categoryService.getCategories(this.page)
        .subscribe(response => {
            $('#page-loader').fadeOut();
            for (const item of response.docs) {
                this.categories.push(item);
            }
            this.pages = response.pages;
        }, error => {
            $('#page-loader').fadeOut();
            this.errorSwal.text = 'Ürünlerin devamı yüklenemedi!';
            this.errorSwal.show();
        });
  }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/categories/categories.component.ts